import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { FilterBarModule, MatcherComponentRegistryService } from '@cdw-ae/filter-bar-core';
import { ContainsMatcherComponent } from './matchers/contains.matcher';
import { FullMatchEditorComponent } from './matchers/full-match.matcher';
import { MultiContainsMatcherComponent } from './matchers/multi-contains-matcher/multi-contains.matcher';
import { MultiTextSearchMatcherComponent } from './matchers/multi-text-search-matcher/multi-text-search.matcher';
import { StartsWithMatcherComponent } from './matchers/starts-with.matcher';
import { TextMatcherComponent } from './matchers/text-matcher/text.matcher';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialLibraryModule,
    FilterBarModule,
    MultiContainsMatcherComponent,
    MultiTextSearchMatcherComponent,
  ],
  declarations: [
    ContainsMatcherComponent,
    StartsWithMatcherComponent,
    FullMatchEditorComponent,
    TextMatcherComponent,
  ],
  exports: [
    ContainsMatcherComponent,
    MultiContainsMatcherComponent,
    MultiTextSearchMatcherComponent,
    StartsWithMatcherComponent,
    FullMatchEditorComponent,
    TextMatcherComponent,
  ],
})
export class FilterBarTextMatchersModule {
  constructor(private matcherRegistry: MatcherComponentRegistryService) {
    // Register text matcher components
    this.matcherRegistry.registerComponent('startsWith', StartsWithMatcherComponent);
    this.matcherRegistry.registerComponent('contains', ContainsMatcherComponent);
    this.matcherRegistry.registerComponent('multiContains', MultiContainsMatcherComponent);
    this.matcherRegistry.registerComponent('multiTextSearch', MultiTextSearchMatcherComponent);
    this.matcherRegistry.registerComponent('fullMatch', FullMatchEditorComponent);
    this.matcherRegistry.registerComponent('enhancedText', TextMatcherComponent);
  }
}
